import * as Yup from 'yup'
import { BaseEntity } from '../../../../shared/models/ApiModels'

export interface IBrandModel extends BaseEntity{ 
  name: string,
} 

export const validationBrand = Yup.object().shape({
  name: Yup.string().required('Marka adı zorunludur'),
})

export const initialBrand: IBrandModel = {
  id: '',
  name: '',
}